import { ACCENT, illustrationA11y, lineStyle } from './static-art';

export function GlobeHeartsIllustration(props: { className?: string; label?: string; ink?: string }) {
	const line = lineStyle(props.ink, 1.21745);
	return (
		<svg
			width="312"
			height="316"
			viewBox="0 0 312 316"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M147.771 266.912C41.9073 261.987 50.3595 161.654 50.3595 161.654C50.3595 161.654 47.6202 56.9749 160.128 62.569C242.707 66.6749 257.079 133.589 257.49 155.838C257.797 172.511 253.634 271.836 147.771 266.912Z"
				{...line}
			/>
			<path
				d="M58.6832 119.921C58.6832 119.921 55.7918 150.245 76.4489 167.596C76.4489 167.596 91.7339 173.793 80.579 190.317C80.579 190.317 78.9264 199.405 92.5587 216.343C106.191 233.281 92.5587 237.825 107.019 247.741C121.479 257.657 111.977 238.653 115.282 231.628C118.588 224.603 123.957 229.561 127.262 214.276C127.262 214.276 131.392 209.318 133.459 200.644C135.526 191.97 124.371 190.643 122.304 186.348C120.237 182.054 119.413 173.79 108.258 172.965C97.1029 172.141 95.8641 171.313 93.3866 162.638C90.9091 153.964 80.993 162.638 81.4069 152.311C81.8208 141.984 84.7123 139.504 92.5618 143.223C92.5618 143.223 95.4532 149.42 100.411 146.528C105.369 143.637 99.9973 138.679 102.478 132.896C104.955 127.113 103.717 122.98 109.089 118.85C109.089 118.85 117.352 118.85 119.005 111C120.657 103.151 117.446 97.3679 133.718 91.585C149.989 85.8021 148.379 63.252 148.379 63.252"
				{...line}
			/>
			<path
				d="M220.142 82.3438C220.142 82.3438 216.024 88.2088 201.947 85.4726C187.87 82.7364 179.659 94.4665 183.959 99.5493C188.26 104.632 187.536 110.108 182.815 110.497C178.094 110.887 171.84 106.586 169.493 114.408C167.146 122.227 162.063 121.838 161.281 126.138C160.499 130.439 162.063 142.562 169.883 136.304C177.702 130.046 174.965 123.399 181.613 126.138C188.26 128.875 182.395 133.957 188.26 135.522C194.125 137.086 192.171 136.691 198.818 138.063C205.465 139.433 212.895 135.132 212.113 140.608C211.331 146.083 211.331 146.473 204.683 146.083C198.036 145.694 198.036 147.477 190.996 146.193C183.956 144.908 183.177 138.261 175.745 141.39C168.315 144.519 153.846 150.384 153.846 171.108C153.846 191.832 174.18 180.884 179.263 181.274C184.346 181.663 192.557 188.703 188.844 205.126C185.128 221.55 184.349 236.019 191.386 236.019C198.423 236.019 196.861 234.847 208.981 217.249C221.104 199.654 208.591 198.479 215.239 185.967C221.886 173.455 218.757 180.427 217.193 165.797C215.628 151.166 216.021 152.73 223.84 154.685C231.659 156.639 228.923 142.562 235.57 145.691C242.217 148.819 242.217 160.16 248.475 159.18C254.733 158.2 256.732 148.427 256.732 148.427"
				{...line}
			/>
			<path
				d="M176.534 123.19C176.534 123.19 169.896 120.11 167.595 115.532C164.81 109.987 172.492 105.153 176.391 109.981C176.44 110.038 176.485 110.099 176.534 110.16"
				fill={ACCENT}
			/>
			<path
				d="M176.534 123.19C176.534 123.19 183.172 120.11 185.473 115.532C188.258 109.987 180.576 105.153 176.677 109.981C176.629 110.038 176.583 110.099 176.534 110.16"
				fill={ACCENT}
			/>
			<path
				d="M157.534 138.19C157.534 138.19 150.896 135.11 148.595 130.532C145.81 124.987 153.492 120.153 157.391 124.981C157.44 125.038 157.485 125.099 157.534 125.16"
				fill={ACCENT}
			/>
			<path
				d="M157.534 138.19C157.534 138.19 164.172 135.11 166.473 130.532C169.258 124.987 161.576 120.153 157.677 124.981C157.629 125.038 157.583 125.099 157.534 125.16"
				fill={ACCENT}
			/>
		</svg>
	);
}
